<template>
	<el-card class="card-container m-t-20" shadow="never">
		<el-table v-loading="loading" :data="tableData" tooltip-effect="light" style="width: 100%" stripe
			:header-cell-style="{ background: '#f8f9fa', color: '#606266', fontWeight: 'bold' }">
			<el-table-column prop="createtime" label="提交查询时间" min-width="160" align="center">
				<template slot-scope="scope">
					<div>{{ formatTime(scope.row.createtime * 1000, 'Y-M-D h:m:s')}}</div>
				</template>

			</el-table-column>
			<el-table-column prop="task_status" label="状态" min-width="200" align="center">
				<template slot-scope="scope">
					<div>
						<el-tooltip v-if="scope.row.task_status == 4&&scope.row.reason" class="item" :content="scope.row.reason">
							<div class="flex align-center justify-center pointer">
								<el-tag size="small" type="danger">导出失败</el-tag>
							</div>
						</el-tooltip>
						<el-tag v-else size="small" :type="scope.row.task_status == 4 ? 'danger' : scope.row.task_status == 3 ? 'success' : 'info'">{{
	scope.row.task_status == 4 ? '导出失败' : scope.row.task_status == 3 ? '导出成功' :
							scope.row.task_status == 2 ? '导出中' : '队列中'
							}}</el-tag>
					</div>

				</template>
			</el-table-column>
			<el-table-column prop="action" label="操作" min-width="120" align="center">
				<template slot-scope="scope">
					<div>
						<a v-if="scope.row.task_status==3" :href="scope.row.file_url" target="_blank">下载</a>
						<el-divider v-if="scope.row.task_status == 3" direction="vertical"></el-divider>
						<a href="javascript:;" @click="handleDetail(scope.row)">任务详情</a>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<div class="pagination-wrapper">
			<el-pagination background layout="total, sizes, prev, pager, next, jumper"
				:current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
				:total="pagination.total" @size-change="handleSizeChange"
				@current-change="handleCurrentChange"></el-pagination>
		</div>
		<download-detail v-if="detailVisible" :isShow="detailVisible" :parames="detailData"
			@close="detailVisible=false" />
	</el-card>
</template>

<script>
import { exportList } from '@/api/public'
import { formatTime } from '@/utils/timeTransfer'
import DownloadDetail from '@/components/DownloadDetail'
export default {
	components: {
		DownloadDetail
	},
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		drawerVisible: {
			get() {
				return this.isShow
			},
			set(val) {

			}
		},
	},
	data() {
		return {
			loading: false,
			tableData: [],
			pagination: {
				total: 0,
				currentPage: 1,
				pageSize: 10

			},
			detailVisible: false,
			detailData:{}
		}
	},
	mounted() {
		this.getList(true)
	},
	methods: {
		formatTime,
		getList(isOnce) {
			if (isOnce) {
				this.pagination.currentPage = 1
			}
			this.loading = true
			exportList({
				source: 99,
				page: this.pagination.currentPage,
				pagesize: this.pagination.pageSize,
			}).then(res => {
				this.tableData = res.data.list || []
				this.pagination.total = res.data.total || 0
			}).finally(() => {
				this.loading = false
			})
		},
		handleSizeChange(val) {
			this.pagination.pageSize = val
			this.getList(true)
		},
		handleCurrentChange(val) {
			this.pagination.currentPage = val
			this.getList()
		},
		handleClose() {
			this.$emit('close')
		},
		handleDetail(row) {
			this.detailData = row
			this.detailVisible = true
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep .el-drawer__header {
	color: #333;
	font-size: 16px;
	font-weight: bold;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
	background-color: #333;
	border-color: #333;
	box-shadow: -1px 0 0 0 #333;
}

::v-deep .el-radio-button__inner:hover {
	color: #333;
}

.drawer-content {
	padding: 0 20px;

	.pagination-wrapper {
		display: flex;
		justify-content: center;
		margin-top: 20px;
		padding-top: 20px;
		border-top: 1px solid #ebeef5;
	}
}
</style>
